export default function usePendo(store) {
  function initPendo() {
    const init = {
      visitor: {
        id: store.state.userEmail,
        email: store.state.userEmail,
        role: store.state.isAdmin ? "admin" : "user",
      },
      account: {
        id: store.state.isInternal ? "Internal" : store.state.styleID,
        clientID: store.state.clientID,
      },
    };

    if (!window.pendo) {
      console.warn("Pendo not initialized.");
      return;
    }

    window.pendo.initialize(init);
  }

  return { initPendo };
}
